import styled from "styled-components";

export const StyledCustomersPageWrapper = styled.div`
  max-width: 82rem;
  margin: 4rem 0;
`;
export const StyledCustomersDataBox = styled.div`
  border: 1px solid #d9d9d9;
  border-radius: 5px;
  padding: 3.2rem 2.5rem;
  position: relative;
  height: 13rem;

  .data-box-title {
    font-size: 1.8rem;
  }
  .data-box-value {
    font-weight: 700;
    font-size: 2.4rem;
  }

  .data-circle {
    position: absolute;
    bottom: 0;
    right: 0;
    background-color: #222222;
    width: 4rem; /* Size of the quarter circle */
    height: 4rem;
    border-top-left-radius: 100px; /* Radius equal to the width/height */
    border-top-right-radius: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    opacity: 20%;
    /* border-radius: 50%; */
  }
`;

export const StyledDashboardMetricsWrapper = styled.div`
  .show-desktop {
    display: block;
  }
  .show-mobile {
    display: none;
  }

  @media only screen and (max-width: 960px) {
    .show-desktop {
      display: none;
    }
    .show-mobile {
      display: block;
    }
  }
`;
export const StyledDashboardMetricsDataBox = styled(StyledCustomersDataBox)``;
